import React, { useState } from 'react';
import { useToast } from '../hooks/use-toast';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    phone: '',
    email: '',
    city: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate age
    const age = parseInt(formData.age);
    if (age < 13 || age > 19) {
      toast({
        title: "Invalid Age",
        description: "Sorry, you must be between 13-19 years old to apply.",
        variant: "destructive",
      });
      return;
    }
    
    setSubmitting(true);
    
    try {
      // Submit to backend
      const response = await axios.post(`${API}/enquiry/submit`, {
        ...formData,
        age: parseInt(formData.age)
      });
      
      // Navigate to confirmation page with enquiry data
      navigate('/registration-confirm', {
        state: { enquiry: response.data }
      });
      
    } catch (error) {
      console.error('Error submitting form:', error);
      toast({
        title: "Submission Failed",
        description: error.response?.data?.detail || "Please try again later.",
        variant: "destructive",
      });
      setSubmitting(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer 
      className="py-12 md:py-16 text-center text-white"
      style={{
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url(/16.jpg)',
        backgroundPosition: 'top',
        backgroundSize: 'cover'
      }}
    >
      <div className="container mx-auto px-4">
        <p className="text-xl md:text-2xl font-semibold mb-2">
          For Queries, Feedback & Assistance
        </p>
        <p className="text-base md:text-lg font-bold text-red-400 mb-6">
          Alee Club Support (8 AM – 10 PM)
        </p>
        <button 
          onClick={scrollToTop}
          className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-8 py-2.5 rounded-full transition-all duration-200 text-sm md:text-base shadow-lg hover:shadow-xl transform hover:-translate-y-1"
        >
          Apply Now
        </button>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10 max-w-6xl mx-auto">
          {/* Left Image */}
          <div className="flex justify-center items-start">
            <img
              src="/Alee-Post.jpg"
              alt="Alee Club"
              className="w-full max-w-md rounded-xl shadow-2xl border-4 border-white/20"
            />
          </div>

          {/* Right Form */}
          <div className="flex justify-center items-start">
            <div className="w-full max-w-md bg-white/10 backdrop-blur-md p-6 rounded-xl shadow-2xl border border-white/20">
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  className="w-full p-3 mb-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500 text-black"
                  placeholder="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  pattern="[A-Za-z0-9_ ]{1,150}"
                  title="Accept Only Name and Space"
                  required
                />

                <input
                  type="number"
                  className="w-full p-3 mb-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500 text-black"
                  placeholder="Your Age (13-19)"
                  name="age"
                  value={formData.age}
                  onChange={handleChange}
                  min="13"
                  max="19"
                  title="Age must be between 13 and 19 years"
                  required
                />

                <input
                  type="tel"
                  className="w-full p-3 mb-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500 text-black"
                  placeholder="+91 9999999999"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  pattern="[7896][0-9]{9}"
                  minLength="10"
                  maxLength="10"
                  required
                />

                <input
                  type="email"
                  className="w-full p-3 mb-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500 text-black"
                  placeholder="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                <input
                  type="text"
                  className="w-full p-3 mb-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500 text-black"
                  placeholder="City"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                />

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {submitting ? 'Submitting...' : 'Apply Now'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;